export const typography = {
    "pageHeader": {
        "introduction": {
            "textAlign": "left",
            "fontStyle": "italic",
            "fontSize": "14px",
            "fontWeight": 300,
            "lineHeight": "25px",
            "textDecoration": "none",
            "color": "hsla(207, 5%, 56.7%, 1.000)"
        },
        "areaTitle": {
            "textAlign": "left",
            "fontSize": "12px",
            "fontWeight": 400,
            "textDecoration": "none",
            "color": "hsla(0, 0%, 46.3%, 1.000)"
        },
        "mainTitle": {
            "textAlign": "left",
            "fontSize": "26px",
            "fontWeight": 600,
            "textDecoration": "none",
            "color": "hsla(208, 7.7%, 38.2%, 1.000)"
        }
    },
    "form": {
        "label": {
            "meta": {
                "textAlign": "left",
                "fontSize": "14px",
                "fontWeight": 300,
                "textDecoration": "none",
                "color": "hsla(0, 0%, 56.1%, 1.000)"
            },
            "default": {
                "textAlign": "left",
                "fontSize": "14px",
                "fontWeight": 400,
                "textDecoration": "none",
                "color": "hsla(207, 5%, 56.7%, 1.000)"
            },
            "disabled": {
                "textAlign": "left",
                "fontSize": "16px",
                "fontWeight": 300,
                "textDecoration": "none",
                "color": "hsla(0, 0%, 46.3%, 0.651)"
            },
            "failure": {
                "textAlign": "left",
                "fontSize": "16px",
                "fontWeight": 400,
                "textDecoration": "none",
                "color": "hsla(0, 67.9%, 67.1%, 1.000)"
            },
            "meta(Selected)": {
                "textAlign": "left",
                "fontSize": "14px",
                "fontWeight": 600,
                "textDecoration": "none",
                "color": "hsla(207, 94.2%, 66.1%, 1.000)"
            }
        },
        "tip": {
            "textAlign": "left",
            "fontStyle": "italic",
            "fontSize": "14px",
            "fontWeight": 500,
            "lineHeight": "25px",
            "textDecoration": "none",
            "color": "hsla(205, 59.7%, 71.8%, 1.000)"
        },
        "button": {
            "secondary": {
                "normal": {
                    "textAlign": "center",
                    "fontSize": "16px",
                    "fontWeight": 600,
                    "textDecoration": "none",
                    "color": "hsla(0, 0%, 55.3%, 1.000)"
                },
                "large": {
                    "textAlign": "center",
                    "fontSize": "20px",
                    "fontWeight": 600,
                    "textDecoration": "none",
                    "color": "hsla(0, 0%, 55.3%, 1.000)"
                },
                "small": {
                    "textAlign": "center",
                    "fontSize": "14px",
                    "fontWeight": 600,
                    "textDecoration": "none",
                    "color": "hsla(0, 0%, 55.3%, 1.000)"
                },
                "xsmall": {
                    "textAlign": "center",
                    "fontSize": "12px",
                    "fontWeight": 600,
                    "textDecoration": "none",
                    "color": "hsla(0, 0%, 55.3%, 1.000)"
                }
            },
            "primary": {
                "large": {
                    "textAlign": "center",
                    "fontSize": "20px",
                    "fontWeight": 600,
                    "textDecoration": "none",
                    "color": "hsla(0, 0%, 100%, 1.000)"
                },
                "normal": {
                    "textAlign": "center",
                    "fontSize": "16px",
                    "fontWeight": 600,
                    "textDecoration": "none",
                    "color": "hsla(0, 0%, 100%, 1.000)"
                },
                "small": {
                    "textAlign": "center",
                    "fontSize": "14px",
                    "fontWeight": 600,
                    "textDecoration": "none",
                    "color": "hsla(0, 0%, 100%, 1.000)"
                },
                "xsmall": {
                    "textAlign": "center",
                    "fontSize": "12px",
                    "fontWeight": 600,
                    "textDecoration": "none",
                    "color": "hsla(0, 0%, 100%, 1.000)"
                }
            },
            "danger": {
                "large": {
                    "textAlign": "center",
                    "fontSize": "20px",
                    "fontWeight": 600,
                    "textDecoration": "none",
                    "color": "hsla(0, 0%, 100%, 1.000)"
                },
                "normal": {
                    "textAlign": "center",
                    "fontSize": "16px",
                    "fontWeight": 600,
                    "textDecoration": "none",
                    "color": "hsla(0, 0%, 100%, 1.000)"
                },
                "small": {
                    "textAlign": "center",
                    "fontSize": "14px",
                    "fontWeight": 600,
                    "textDecoration": "none",
                    "color": "hsla(0, 0%, 100%, 1.000)"
                },
                "xsmall": {
                    "textAlign": "center",
                    "fontSize": "12px",
                    "fontWeight": 600,
                    "textDecoration": "none",
                    "color": "hsla(0, 0%, 100%, 1.000)"
                }
            }
        },
        "input": {
            "label": {
                "textAlign": "left",
                "fontSize": "14px",
                "fontWeight": 400,
                "textDecoration": "none",
                "color": "hsla(207, 5%, 56.7%, 1.000)"
            },
            "placeholder": {
                "normal": {
                    "textAlign": "left",
                    "fontStyle": "italic",
                    "fontSize": "16px",
                    "fontWeight": 500,
                    "textDecoration": "none",
                    "color": "hsla(0, 0%, 46.3%, 0.502)"
                },
                "compact": {
                    "textAlign": "left",
                    "fontStyle": "italic",
                    "fontSize": "14px",
                    "fontWeight": 500,
                    "lineHeight": "15px",
                    "textDecoration": "none",
                    "color": "hsla(0, 0%, 46.3%, 0.502)"
                }
            },
            "value": {
                "normal": {
                    "textAlign": "left",
                    "fontSize": "16px",
                    "fontWeight": 500,
                    "lineHeight": "25px",
                    "textDecoration": "none",
                    "color": "hsla(207, 5%, 56.7%, 1.000)"
                },
                "compact": {
                    "textAlign": "left",
                    "fontSize": "14px",
                    "fontWeight": 500,
                    "lineHeight": "15px",
                    "textDecoration": "none",
                    "color": "hsla(207, 5%, 56.7%, 1.000)"
                }
            }
        },
        "labelInformation": {
            "textAlign": "left",
            "fontStyle": "italic",
            "fontSize": "14px",
            "fontWeight": 300,
            "lineHeight": "25px",
            "textDecoration": "none",
            "color": "hsla(207, 5%, 56.7%, 1.000)"
        },
        "select": {
            "option": {
                "textAlign": "left",
                "fontSize": "16px",
                "fontWeight": 500,
                "lineHeight": "15px",
                "textDecoration": "none",
                "color": "hsla(207, 5%, 56.7%, 1.000)"
            },
            "selectedValue": {
                "textAlign": "left",
                "fontSize": "16px",
                "fontWeight": 500,
                "lineHeight": "15px",
                "textDecoration": "none",
                "color": "hsla(0, 0%, 17.6%, 1.000)"
            },
            "option(Hover)": {
                "textAlign": "left",
                "fontSize": "16px",
                "fontWeight": 500,
                "lineHeight": "15px",
                "textDecoration": "none",
                "color": "hsla(207, 41.2%, 53.3%, 1.000)"
            }
        },
        "feedback": {
            "message": {
                "textAlign": "left",
                "fontStyle": "italic",
                "fontSize": "14px",
                "fontWeight": 500,
                "lineHeight": "20px",
                "textDecoration": "none",
                "color": "hsla(0, 0%, 100%, 1.000)"
            }
        }
    },
    "global": {
        "mainMenu": {
            "menuItem": {
                "default": {
                    "textAlign": "left",
                    "fontSize": "16px",
                    "fontWeight": 300,
                    "textDecoration": "none",
                    "color": "hsla(0, 0%, 34.5%, 0.847)"
                },
                "active": {
                    "textAlign": "left",
                    "fontSize": "16px",
                    "fontWeight": 300,
                    "textDecoration": "none",
                    "color": "hsla(0, 0%, 34.5%, 0.851)"
                },
                "hover": {
                    "textAlign": "left",
                    "fontSize": "16px",
                    "fontWeight": 300,
                    "textDecoration": "none",
                    "color": "hsla(0, 0%, 34.5%, 0.851)"
                }
            },
            "subheader": {
                "textAlign": "left",
                "fontSize": "14px",
                "fontWeight": 600,
                "textTransform": "uppercase",
                "letterSpacing": "0.35px",
                "textDecoration": "none",
                "color": "hsla(0, 0%, 34.5%, 0.902)"
            },
            "hidePrompt": {
                "textAlign": "left",
                "fontSize": "14px",
                "fontWeight": 300,
                "textDecoration": "none",
                "color": "hsla(0, 0%, 34.5%, 1.000)"
            },
            "subItem": {
                "default": {
                    "textAlign": "left",
                    "fontSize": "14px",
                    "fontWeight": 300,
                    "textDecoration": "none",
                    "color": "hsla(0, 0%, 34.5%, 0.647)"
                },
                "active": {
                    "textAlign": "left",
                    "fontSize": "14px",
                    "fontWeight": 600,
                    "textDecoration": "none",
                    "color": "hsla(214, 14.4%, 46.3%, 1.000)"
                },
                "hover": {
                    "textAlign": "left",
                    "fontSize": "14px",
                    "fontWeight": 300,
                    "textDecoration": "none",
                    "color": "hsla(214, 14.4%, 46.3%, 1.000)"
                }
            },
            "identity": {
                "textAlign": "left",
                "fontSize": "12px",
                "fontWeight": 400,
                "textDecoration": "none",
                "color": "hsla(0, 0%, 34.1%, 0.749)"
            }
        },
        "topBar": {
            "search": {
                "value": {
                    "textAlign": "left",
                    "fontSize": "14px",
                    "fontWeight": 300,
                    "textDecoration": "none",
                    "color": "hsla(0, 0%, 34.9%, 1.000)"
                },
                "placeholder": {
                    "textAlign": "left",
                    "fontStyle": "italic",
                    "fontSize": "14px",
                    "fontWeight": 300,
                    "textDecoration": "none",
                    "color": "hsla(0, 0%, 65.5%, 1.000)"
                }
            }
        }
    },
    "content": {
        "section-H2": {
            "textAlign": "left",
            "fontSize": "20px",
            "fontWeight": 400,
            "textDecoration": "none",
            "color": "hsla(208, 7.7%, 38.2%, 1.000)"
        },
        "sectionH3": {
            "textAlign": "left",
            "fontSize": "16px",
            "fontWeight": 400,
            "textDecoration": "none",
            "color": "hsla(208, 7.7%, 38.2%, 1.000)"
        },
        "actionParagraph": {
            "textAlign": "left",
            "fontSize": "14px",
            "fontWeight": 300,
            "lineHeight": "25px",
            "textDecoration": "none",
            "color": "hsla(207, 5%, 56.7%, 1.000)"
        },
        "hyperlink": {
            "hover": {
                "textAlign": "left",
                "fontStyle": "italic",
                "fontSize": "14px",
                "fontWeight": 500,
                "lineHeight": "25px",
                "textDecoration": "none",
                "color": "hsla(195, 98.3%, 45.1%, 1.000)"
            },
            "base": {
                "textAlign": "left",
                "fontStyle": "italic",
                "fontSize": "14px",
                "fontWeight": 500,
                "lineHeight": "25px",
                "textDecoration": "none",
                "color": "hsla(205, 62.3%, 55.3%, 1.000)"
            }
        }
    },
    "feedbackBar": {
        "message": {
            "textAlign": "left",
            "fontSize": "14px",
            "fontWeight": 400,
            "lineHeight": "15px",
            "letterSpacing": "-0.2px",
            "textDecoration": "none",
            "color": "hsla(0, 0%, 100%, 1.000)"
        }
    },
    "searchBar": {
        "placeholder": {
            "textAlign": "left",
            "fontStyle": "italic",
            "fontSize": "14px",
            "fontWeight": 700,
            "textDecoration": "none",
            "color": "hsla(0, 0%, 46.3%, 0.647)"
        },
        "value": {
            "textAlign": "left",
            "fontSize": "14px",
            "fontWeight": 600,
            "textDecoration": "none",
            "color": "hsla(207, 5%, 56.7%, 1.000)"
        }
    },
    "meta": {
        "tagList": {
            "emptyStates": {
                "normal": {
                    "textAlign": "left",
                    "fontStyle": "italic",
                    "fontSize": "14px",
                    "fontWeight": 500,
                    "textDecoration": "none",
                    "color": "hsla(0, 0%, 46.3%, 1.000)"
                },
                "small": {
                    "textAlign": "left",
                    "fontStyle": "italic",
                    "fontSize": "12px",
                    "fontWeight": 500,
                    "textDecoration": "none",
                    "color": "hsla(0, 0%, 46.3%, 1.000)"
                }
            },
            "item": {
                "normal": {
                    "textAlign": "left",
                    "fontSize": "14px",
                    "fontWeight": 600,
                    "textDecoration": "none",
                    "color": "hsla(200, 3%, 38.8%, 1.000)"
                },
                "small": {
                    "textAlign": "left",
                    "fontSize": "12px",
                    "fontWeight": 600,
                    "textDecoration": "none",
                    "color": "hsla(200, 3%, 38.8%, 1.000)"
                }
            }
        }
    },
    "table": {
        "columnData": {
            "normalImportance": {
                "right": {
                    "textAlign": "right",
                    "fontSize": "14px",
                    "fontWeight": 500,
                    "textDecoration": "none",
                    "color": "hsla(195, 9.8%, 51.8%, 0.722)"
                },
                "left": {
                    "textAlign": "left",
                    "fontSize": "14px",
                    "fontWeight": 500,
                    "textDecoration": "none",
                    "color": "hsla(195, 9.8%, 51.8%, 0.722)"
                },
                "center": {
                    "textAlign": "center",
                    "fontSize": "14px",
                    "fontWeight": 500,
                    "textDecoration": "none",
                    "color": "hsla(195, 9.8%, 51.8%, 0.722)"
                }
            },
            "highImportance": {
                "right": {
                    "textAlign": "right",
                    "fontSize": "14px",
                    "fontWeight": 900,
                    "textDecoration": "none",
                    "color": "hsla(196, 9.7%, 55.7%, 1.000)"
                },
                "center": {
                    "textAlign": "center",
                    "fontSize": "14px",
                    "fontWeight": 900,
                    "textDecoration": "none",
                    "color": "hsla(196, 9.7%, 55.7%, 1.000)"
                },
                "left": {
                    "textAlign": "left",
                    "fontSize": "14px",
                    "fontWeight": 900,
                    "textDecoration": "none",
                    "color": "hsla(196, 9.7%, 55.7%, 1.000)"
                }
            },
            "firstColumn": {
                "textAlign": "left",
                "fontSize": "14px",
                "fontWeight": 500,
                "textDecoration": "none",
                "color": "hsla(194, 10.2%, 52%, 1.000)"
            },
            "lowImportance": {
                "right": {
                    "textAlign": "right",
                    "fontStyle": "italic",
                    "fontSize": "14px",
                    "fontWeight": 500,
                    "textDecoration": "none",
                    "color": "hsla(195, 9.8%, 51.8%, 0.722)"
                },
                "center": {
                    "textAlign": "center",
                    "fontStyle": "italic",
                    "fontSize": "14px",
                    "fontWeight": 500,
                    "textDecoration": "none",
                    "color": "hsla(195, 9.8%, 51.8%, 0.722)"
                },
                "left": {
                    "textAlign": "left",
                    "fontStyle": "italic",
                    "fontSize": "14px",
                    "fontWeight": 500,
                    "textDecoration": "none",
                    "color": "hsla(195, 9.8%, 51.8%, 0.722)"
                }
            },
            "unit": {
                "textAlign": "right",
                "fontStyle": "italic",
                "fontSize": "12px",
                "fontWeight": 500,
                "textDecoration": "none",
                "color": "hsla(195, 9.8%, 51.8%, 0.722)"
            }
        },
        "header": {
            "center": {
                "textAlign": "center",
                "fontSize": "14px",
                "fontWeight": 700,
                "letterSpacing": "0.4px",
                "textDecoration": "none",
                "color": "hsla(204, 2.4%, 59%, 1.000)"
            },
            "left": {
                "textAlign": "left",
                "fontSize": "14px",
                "fontWeight": 700,
                "letterSpacing": "0.4px",
                "textDecoration": "none",
                "color": "hsla(204, 2.4%, 59%, 1.000)"
            },
            "right": {
                "textAlign": "right",
                "fontSize": "14px",
                "fontWeight": 700,
                "letterSpacing": "0.4px",
                "textDecoration": "none",
                "color": "hsla(204, 2.4%, 59%, 1.000)"
            }
        },
        "subHeader": {
            "center": {
                "textAlign": "center",
                "fontSize": "14px",
                "fontWeight": 700,
                "letterSpacing": "0.4px",
                "textDecoration": "none",
                "color": "hsla(204, 2.4%, 59%, 1.000)"
            },
            "left": {
                "textAlign": "left",
                "fontSize": "14px",
                "fontWeight": 700,
                "letterSpacing": "0.4px",
                "textDecoration": "none",
                "color": "hsla(204, 2.4%, 59%, 1.000)"
            },
            "right": {
                "textAlign": "right",
                "fontSize": "14px",
                "fontWeight": 700,
                "letterSpacing": "0.4px",
                "textDecoration": "none",
                "color": "hsla(204, 2.4%, 59%, 1.000)"
            }
        }
    },
    "filters": {
        "datepicker": {
            "metaHeader": {
                "default": {
                    "textAlign": "left",
                    "fontSize": "14px",
                    "fontWeight": 300,
                    "textDecoration": "none",
                    "color": "hsla(0, 0%, 56.1%, 1.000)"
                },
                "active": {
                    "textAlign": "left",
                    "fontSize": "14px",
                    "fontWeight": 600,
                    "textDecoration": "none",
                    "color": "hsla(207, 94.2%, 66.1%, 1.000)"
                }
            },
            "calendar": {
                "active": {
                    "textAlign": "center",
                    "fontSize": "14px",
                    "fontWeight": 400,
                    "textDecoration": "none",
                    "color": "hsla(0, 0%, 100%, 1.000)"
                },
                "otherMonth": {
                    "textAlign": "center",
                    "fontSize": "14px",
                    "fontWeight": 400,
                    "textDecoration": "none",
                    "color": "hsla(206, 6.3%, 49.4%, 0.502)"
                },
                "default": {
                    "textAlign": "center",
                    "fontSize": "14px",
                    "fontWeight": 400,
                    "textDecoration": "none",
                    "color": "hsla(0, 0%, 46.3%, 1.000)"
                },
                "header": {
                    "textAlign": "center",
                    "fontSize": "12px",
                    "fontWeight": 700,
                    "textDecoration": "none",
                    "color": "hsla(0, 0%, 82%, 1.000)"
                }
            },
            "monthLink": {
                "default": {
                    "textAlign": "center",
                    "fontSize": "12px",
                    "fontWeight": 700,
                    "lineHeight": "20px",
                    "textTransform": "uppercase",
                    "letterSpacing": "0.4px",
                    "textDecoration": "none",
                    "color": "hsla(0, 0%, 75.7%, 1.000)"
                },
                "hover": {
                    "textAlign": "center",
                    "fontSize": "12px",
                    "fontWeight": 700,
                    "lineHeight": "20px",
                    "textTransform": "uppercase",
                    "letterSpacing": "0.4px",
                    "textDecoration": "none",
                    "color": "hsla(0, 0%, 100%, 1.000)"
                }
            },
            "focusedMonth": {
                "textAlign": "center",
                "fontSize": "20px",
                "fontWeight": 400,
                "lineHeight": "20px",
                "letterSpacing": "0.5px",
                "textDecoration": "none",
                "color": "hsla(215, 23.5%, 64.1%, 1.000)"
            },
            "focusedYear": {
                "textAlign": "center",
                "fontSize": "10px",
                "fontWeight": 700,
                "lineHeight": "20px",
                "textTransform": "uppercase",
                "letterSpacing": "0.3333333px",
                "textDecoration": "none",
                "color": "hsla(215, 23.5%, 64.1%, 1.000)"
            }
        },
        "value": {
            "textAlign": "left",
            "fontSize": "14px",
            "fontWeight": 500,
            "letterSpacing": "0.2px",
            "textDecoration": "none",
            "color": "hsla(0, 0%, 56.1%, 1.000)"
        },
        "subOption": {
            "label": {
                "textAlign": "left",
                "fontSize": "12px",
                "fontWeight": 300,
                "textDecoration": "none",
                "color": "hsla(0, 0%, 46.3%, 1.000)"
            },
            "value": {
                "textAlign": "left",
                "fontSize": "13px",
                "fontWeight": 500,
                "textDecoration": "none",
                "color": "hsla(202, 6.2%, 74.5%, 1.000)"
            }
        },
        "presetAction": {
            "textAlign": "left",
            "fontSize": "13px",
            "fontWeight": 500,
            "textDecoration": "none",
            "color": "hsla(202, 6.2%, 74.5%, 1.000)"
        },
        "filterButton": {
            "default": {
                "textAlign": "left",
                "fontSize": "12px",
                "fontWeight": 400,
                "textDecoration": "none",
                "color": "hsla(0, 0%, 50.2%, 1.000)"
            },
            "active": {
                "textAlign": "left",
                "fontSize": "12px",
                "fontWeight": 400,
                "textDecoration": "none",
                "color": "hsla(0, 0%, 100%, 1.000)"
            },
            "hover": {
                "textAlign": "left",
                "fontSize": "12px",
                "fontWeight": 400,
                "textDecoration": "none",
                "color": "hsla(0, 0%, 100%, 1.000)"
            }
        },
        "searchInput": {
            "placeholder": {
                "textAlign": "left",
                "fontStyle": "italic",
                "fontSize": "12px",
                "fontWeight": 500,
                "textDecoration": "none",
                "color": "hsla(0, 0%, 46.3%, 0.647)"
            },
            "value": {
                "textAlign": "left",
                "fontSize": "12px",
                "fontWeight": 400,
                "textDecoration": "none",
                "color": "hsla(0, 0%, 50.2%, 1.000)"
            }
        }
    },
    "tables": {
        "groupName": {
            "textAlign": "left",
            "fontSize": "12px",
            "fontWeight": 400,
            "letterSpacing": "0.3px",
            "textDecoration": "none",
            "color": "hsla(210, 2.4%, 51%, 0.651)"
        }
    },
    "modal": {
        "title": {
            "textAlign": "left",
            "fontSize": "20px",
            "fontWeight": 400,
            "textShadow": "0px 0px 10px #ffffffcc",
            "textDecoration": "none",
            "color": "hsla(210, 5.8%, 47.5%, 1.000)"
        },
        "basicContent": {
            "textAlign": "left",
            "fontSize": "14px",
            "fontWeight": 400,
            "lineHeight": "25px",
            "textDecoration": "none",
            "color": "hsla(200, 1.2%, 49.2%, 1.000)"
        }
    }
};